'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _express2 = _interopRequireDefault(_express);

var _minimajs = require('minimajs');

var _artTemplate = require('art-template');

var _artTemplate2 = _interopRequireDefault(_artTemplate);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minimaMenusExtensionPoint = 'minima.menus';

var IndexRoute = function () {
    /**
     * @param {Minima} minima
     * @param {Express} app
     * @memberof IndexRoute
     */
    function IndexRoute(minima, app) {
        (0, _classCallCheck3.default)(this, IndexRoute);

        this.minima = minima;
        this.app = app;

        this.handleExtensions = this.handleMenusExtensions.bind(this);
        this.extensionChangedListener = this.extensionChangedListener.bind(this);
        this.parseChildLevel = this.parseChildLevel.bind(this);
        this.createRoute = this.createRoute.bind(this);
        this.createIndexRoute = this.createIndexRoute.bind(this);
        this.createPluginViewRoute = this.createPluginViewRoute.bind(this);
        this.showResponse = this.showResponse.bind(this);
        this.showError = this.showError.bind(this);

        this.handleMenusExtensions();
        this.minima.addExtensionChangedListener(this.extensionChangedListener);

        this.createRoute();
    }

    (0, _createClass3.default)(IndexRoute, [{
        key: 'createRoute',
        value: function createRoute() {
            this.app.use(this.createIndexRoute());
            this.app.use(this.createPluginViewRoute());
        }

        /**
         *
         *
         * @param {Extension} extension
         * @param {any} action
         * @memberof IndexRoute
         */

    }, {
        key: 'extensionChangedListener',
        value: function extensionChangedListener(extension, action) {
            if (extension.id === minimaMenusExtensionPoint) {
                this.handleMenusExtensions();
            }
        }
    }, {
        key: 'handleMenusExtensions',
        value: function handleMenusExtensions() {
            MenuData.menuId = 0;
            /**
             * @type {MenuData[]}
             */
            this.menus = [];
            /**
             * @type {Map.<number, MenuData>}
             */
            this.menuMap = new _map2.default();

            var extensions = this.minima.getExtensions(minimaMenusExtensionPoint);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(extensions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var extension = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(extension.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var menu = _step2.value;

                            var menuData = new MenuData(extension.owner, menu);
                            this.menuMap.set(menuData.id, menuData);

                            this.parseChildLevel(extension.owner, menuData, menu);
                            this.menus.push(menuData);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.menus.sort(function (a, b) {
                return a.order - b.order;
            });
        }

        /**
         *
         *
         * @param {MenuData} menuData
         * @param {Object} menu
         * @memberof IndexRoute
         */

    }, {
        key: 'parseChildLevel',
        value: function parseChildLevel(plugin, menuData, menu) {
            if (!menu.menus) {
                return;
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(menu.menus), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var childMenu = _step3.value;

                    var childMenuData = new MenuData(plugin, childMenu);
                    this.menuMap.set(childMenuData.id, childMenuData);

                    menuData.addMenu(childMenuData);
                    this.parseChildLevel(plugin, childMenuData, childMenu);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            menuData.sort();
        }
    }, {
        key: 'createIndexRoute',
        value: function createIndexRoute() {
            var self = this;
            var route = new _express2.default.Router();
            route.get('/', function (req, res) {
                var extensionPoint = "minima.webapis";
                var extensions = self.minima.getExtensions(extensionPoint);
                var webapis = [];
                var index = 1;
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = (0, _getIterator3.default)(extensions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var extension = _step4.value;

                        webapis.push({
                            index: index,
                            pluginId: extension.owner.id,
                            pluginName: extension.owner.name,
                            pluginVersion: extension.owner.version.versionString,
                            path: '/' + extension.owner.id + '/' + extension.data.path,
                            method: extension.data.method,
                            handler: extension.data.handler
                        });
                        index++;
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                res.render('index', { menus: self.menus, pluginsCount: self.minima.getPlugins().size, webApisCount: extensions.size, webapis: webapis });
            });
            return route;
        }
    }, {
        key: 'createPluginViewRoute',
        value: function createPluginViewRoute() {
            var _this = this;

            var route = new _express2.default.Router();
            var self = this;

            route.get('/pluginView', function (request, response) {
                try {
                    var menuId = parseInt(request.query.id);
                    var menu = _this.menuMap.get(menuId);

                    if (menu.isHtmlView) {
                        self.showResponse(response, menu.loadHtmlView());
                        return;
                    }

                    var renderClass = menu.loadRender();
                    if (renderClass) {
                        var render = new renderClass();
                        if (render.renderAsync) {
                            render.renderAsync(function (html) {
                                self.showResponse(response, html);
                            });
                        } else {
                            self.showResponse(response, render.render());
                        }
                    } else {
                        throw new Error('Failed to load menu.');
                    }
                } catch (error) {
                    _minimajs.log.logger.error('Render view error.', error);
                    _this.showError(response, error);
                }
            });
            return route;
        }
    }, {
        key: 'showResponse',
        value: function showResponse(response, html) {
            if (!html) {
                html = 'Not Found.';
            }

            response.writeHead(200, { 'Content-Type': 'text/html' });
            response.write(html);
            response.end();
        }
    }, {
        key: 'showError',
        value: function showError(response, error) {
            var html = (0, _artTemplate2.default)(_path2.default.join(_path2.default.resolve('./views'), 'error-render.html'), {
                message: error.message,
                error: error.stack.replace('\n', '<br />').replace('\r', '<br />').replace('\r\n', '<br />')
            });
            response.writeHead(200, { 'Content-Type': 'text/html' });
            response.write(html);
            response.end();
        }
    }]);
    return IndexRoute;
}();

exports.default = IndexRoute;

var MenuData = function () {
    function MenuData(plugin, menu) {
        (0, _classCallCheck3.default)(this, MenuData);

        MenuData.menuId = MenuData.menuId + 1;
        this._id = MenuData.menuId;

        /**
         * @type {Plugin}
         */
        this.plugin = plugin;

        this._order = parseInt(menu.order);
        if (isNaN(this._order)) {
            this._order = 0;
        }

        this._url = menu.url;
        if (!this._url) {
            this._url = '';
        }

        this._icon = menu.icon;
        if (!this._icon) {
            this._icon = '';
        }

        this._text = menu.text;

        /**
         * @type {MenuData[]}
         */
        this._menus = [];

        this.sort = this.sort.bind(this);
        this.addMenu = this.addMenu.bind(this);
        this.render = this.loadRender.bind(this);
        this.loadHtmlView = this.loadHtmlView.bind(this);
    }

    (0, _createClass3.default)(MenuData, [{
        key: 'loadHtmlView',
        value: function loadHtmlView() {
            if (!this.url) {
                return;
            }
            var viewPath = _path2.default.join(this.plugin.pluginDirectory, this.url);
            return (0, _artTemplate2.default)(viewPath, {});
        }
    }, {
        key: 'loadRender',
        value: function loadRender() {
            if (!this.url) {
                return;
            }

            var render = this.plugin.loadClass(this.url);
            if (render && render.default) {
                return render.default;
            }

            return null;
        }
    }, {
        key: 'sort',
        value: function sort() {
            this._menus.sort(function (a, b) {
                return a.order - b.order;
            });
        }
    }, {
        key: 'addMenu',
        value: function addMenu(menu) {
            this._menus.push(menu);
        }
    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }
    }, {
        key: 'text',
        get: function get() {
            return this._text;
        }
    }, {
        key: 'url',
        get: function get() {
            return this._url;
        }
    }, {
        key: 'icon',
        get: function get() {
            return this._icon;
        }
    }, {
        key: 'order',
        get: function get() {
            return this._order;
        }
    }, {
        key: 'menus',
        get: function get() {
            return this._menus;
        }
    }, {
        key: 'isHtmlView',
        get: function get() {
            return this.url.endsWith('.html');
        }
    }]);
    return MenuData;
}();

MenuData.menuId = 0;
//# sourceMappingURL=IndexRoute.js.map